export const STORAGE_KEY = `moneracy`
export const THEMES = [`light`, `dark`] as const
export const DEFAULT_THEME = `system`
